import { summaryLabelMap } from './configs'

import type { LabelValueRowData } from '@app/components/LabelValueTable/types'
import type { MonitoringListSummaryDto } from '@app/api/routes/monitoringLists/dtos'

export const getLabelValueDataFromSummary = (entity: MonitoringListSummaryDto): LabelValueRowData[] => {
  return Object.entries(entity).map<LabelValueRowData>(([key, value]) => ({
    label: summaryLabelMap[key as keyof MonitoringListSummaryDto],
    value
  }))
}
